import React from "react"
import useSSR from "use-ssr"
import { breakpoints } from "@capioweb/ui-components"

export const useSetCols = (content: any[]) => {
	const { isServer } = useSSR()
	const [cols, setCols] = React.useState([content])

	React.useEffect(() => {
		if (isServer) return

		if (window.innerWidth > breakpoints.l && content?.length > 0) {
			setCols([
				[...content.slice(0, Math.ceil(content.length + 1) / 2)],
				[...content.slice(Math.ceil(content.length + 1) / 2)],
			])
		}
	}, [])

	return { cols }
}
